import { CancelTokenSource } from 'axios';
import {
  MedicamentDto,
  MedicamentSearchRequest,
  PrescriptionMedicamentDto,
  UpdateMedicamentRequest,
  UpdateWsIndexRequest,
  UpdateWsIndexResponse,
  UpsertMedicamentDto,
  WsIndexAddRequest,
  WsIndexAddSearchRequest,
  WsIndexAddSearchResponse
} from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/medicaments`;

export const searchSelectedMedicaments = async (
    description: string, source: CancelTokenSource)
    : Promise<Array<MedicamentDto>> => {

  return axios
      .get(
          `${apiUri}/search`,
          {params: {description}, cancelToken: source.token}
      )
      .then(response => response.data);
};

export const searchMedicaments = async (
    medicamentSearchRequest: Partial<MedicamentSearchRequest>,
    source: CancelTokenSource) => {

  return axios
      .post(
          `${apiUri}/search`,
          medicamentSearchRequest,
          {cancelToken: source.token}
      )
      .then(response => response.data);
};

export const getAllTariffCodes = async (source: CancelTokenSource) => {
  return axios
      .get(`${apiUri}/tariff-codes`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllSelectedMedicamentsByTariffCode = (tariffCode: string, source: CancelTokenSource): Promise<Array<MedicamentDto>> => {
  return axios
      .get(`${apiUri}/selected/${tariffCode}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getAllShippableMedicaments = (source: CancelTokenSource): Promise<Array<MedicamentDto>> => {
  return axios
      .get(`${apiUri}/shippable`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getCompanyShippableMedicaments = (companyId: number, source: CancelTokenSource): Promise<Array<MedicamentDto>> => {
  return axios
      .get(`${apiUri}/shippable/${companyId}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getAllVaccinationMedicaments = (source: CancelTokenSource): Promise<Array<MedicamentDto>> => {
  return axios
      .get(`${apiUri}/vaccination`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const findMedicamentById = (id: number, source: CancelTokenSource): Promise<UpsertMedicamentDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const updateSingleMedicamentSelection = (updateMedicamentRequest: UpdateMedicamentRequest,
                                                source: CancelTokenSource): Promise<boolean> => {
  return axios
      .post(`${apiUri}/selection/single`, updateMedicamentRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const updateMedicamentSelection = (medicaments: Array<number>,
                                          tariffCode: string,
                                          source: CancelTokenSource): Promise<Array<MedicamentDto>> => {
  return axios
      .post(`${apiUri}/selection/${tariffCode}`, medicaments, {cancelToken: source.token})
      .then(response => response.data)
};

export const addMedicament = (upsertMedicamentDto: Partial<UpsertMedicamentDto>,
                              source: CancelTokenSource): Promise<MedicamentDto> => {
  return axios
      .post(apiUri, upsertMedicamentDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editMedicament = (id: number, upsertMedicamentDto: Partial<UpsertMedicamentDto>,
                               source: CancelTokenSource): Promise<MedicamentDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertMedicamentDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteMedicament = (id: number, source: CancelTokenSource): Promise<MedicamentDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const updateWsIndexMedicaments = (request: UpdateWsIndexRequest,
                                         selected: boolean,
                                         source: CancelTokenSource): Promise<UpdateWsIndexResponse> => {
  return axios
      .post(`${apiUri}/update`, request, {params: {selected: selected}, cancelToken: source.token})
      .then(response => response.data);
};

export const wsIndexAddSearchMedicaments = (request: Partial<WsIndexAddSearchRequest>,
                                            source: CancelTokenSource): Promise<WsIndexAddSearchResponse> => {
  return axios
      .post(`${apiUri}/ws-index-search`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const wsIndexAddMedicaments = (request: WsIndexAddRequest,
                                      source: CancelTokenSource): Promise<WsIndexAddSearchResponse> => {
  return axios
      .post(`${apiUri}/ws-index-add`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const getMedicamentsWithDosages = (source: CancelTokenSource): Promise<Array<PrescriptionMedicamentDto>> => {
  return axios
      .get(`${baseUrl}/api/prescription-medicaments`, {cancelToken: source.token})
      .then(response => response.data)
};

